import React, { Component } from "react";
import ImageGallery from "react-image-gallery";
import _ from "lodash";

class ImageViewer extends Component {
  render() {
    const images = this.props.images
      ? this.props.images.filter(img => img !== null).map((img, i) => ({
        original: img,
        thumbnail: img
      }))
          : [];

    const gallery = _.isEmpty(images) ? (
      <div className="col-md-3" />
    ) : (
        <div className="col-md-6">
          <ImageGallery
            items={images}
            autoPlay={true}
            lazyLoad={true}
          // defaultImage="img/logo/logo.png"
          />
        </div>
      );

    return gallery;
  }
}

export default ImageViewer;
